import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useU2000AxiosAuthenticated from '../../../u2000Core/axios/U2000UseAxiosAuthenticated';
import { U2000HandleApiError } from '../../../u2000Core/axios/U2000HandleApiError';
import { useToast } from '../../../u2000Core/context/toast/U2000ToastContext';
import type { U2000AutoCompleteSearchResult } from '../../../u2000Core/types/U2000AutoCompleteSearchResult';
import { u2000ExtractAutoCompleteResults } from '../../../u2000Core/utils/u2000ExtractAutoCompleteResults';
import { NS } from '../../U3139';
import {
  doFindSearchCadastres,
  luHandleAppiError,
  type U3139FindSearchCadastreCriterias,
  type U3139FindSearchCadastreItem,
} from '../../U3139Service';

export { u3139FindSearchCadastreItemToDisplay } from './U3139FindSearchCadastreDisplay';

/** Autocomplete critère liste — POST /U3139/findSearchCadastres (BL-0102). */
export function useU3139FindSearchCadastresHandlers() {
  const axios = useU2000AxiosAuthenticated();
  const { t } = useTranslation();
  const toast = useToast();

  const search = useCallback(
    async (
      criterias: U3139FindSearchCadastreCriterias,
    ): Promise<U2000AutoCompleteSearchResult<U3139FindSearchCadastreItem>> => {
      try {
        const response = await doFindSearchCadastres(axios, criterias);
        return u2000ExtractAutoCompleteResults<U3139FindSearchCadastreItem>(response.data);
      } catch (error: unknown) {
        const errorResult = U2000HandleApiError(error as Error, t, NS, luHandleAppiError);
        if (errorResult.genericErrors?.length) {
          errorResult.genericErrors.forEach((err) => toast.error(err.text, err.title));
        }
        return { results: [], totalCount: 0, truncated: false };
      }
    },
    [axios, t, toast],
  );

  return { search };
}
